/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Step1_TitleInputs */

const en_serve_step1_title = /** @type {(inputs: Serve_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Install Node.js`)
};

const id_serve_step1_title = /** @type {(inputs: Serve_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Pasang Node.js`)
};

/**
* | output |
* | --- |
* | "1. Install Node.js" |
*
* @param {Serve_Step1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_step1_title = /** @type {((inputs?: Serve_Step1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Step1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_step1_title(inputs)
	return en_serve_step1_title(inputs)
});